import styled, { css } from 'styled-components';

// CSS for IE 11
// @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
//   /* add your IE10-IE11 css here */   
// }

const flexFix = css`
	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { 
		display: block;
	}
`;

export const Container = styled.div`
	position: absolute;
	overflow: hidden;
	z-index: 999;
	top: 10px;
	left: 10px;
	height: calc(100% - 20px);
	width: calc(100% - 20px);
	display: flex;

	opacity: ${props => props.visible ? '1' : '0'};
	pointer-events: ${props => props.visible ? 'all' : 'none'};

	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5);

	> div{
		transform: ${props => props.visible ? 'translateY(0)' : 'translateY(30px)'};
		opacity: ${props => props.visible ? '1' : '0'};
		transition: transform 300ms, opacity 300ms;
	}
`;

export const Modal = styled.div`
	width: 90%;
	max-width: ${props => props?.extraWide? '1800px' : '900px'};
  max-height: 90%;
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
    min-height: 0px;
 	} 
	background-color: white;
	display: flex;
	${flexFix}
	flex-direction: column;
	align-items: center;
	box-shadow: 0 20px 30px -15px black;
	font-family: 'Poppins', sans-serif;
	font-size: 18px;
	overflow: visible;
	position: relative;

	iframe{
		height: 506px;
		display: block;
	}

	p{
		line-height: 1.4;
		@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
			line-height: inherit;
		}
		margin-bottom: 30px;
	}

	p:last-child{
		margin-bottom: 0;
	}

	img{
		width: 100%;
		height: auto;
	}

	.close-icon{
		position: absolute;
		top: -40px;
		left: auto;
		right: 0;
		font-size: 25px;
		color: #333;
		padding: 10px;
		background: rgba(255, 255, 255, 0.7);
		width: 40px;
		height: 40px;
		cursor: pointer;
		transition: background 200ms;

		@media(min-width: 900px) {
			top: 0;
			left: 100%;
			right: auto;
			width: 50px;
			height: 50px;			
		}		
	}

	.close-icon:hover{
		background: rgba(255, 255, 255, 1);
	}

	.slick-next {
		right: -30px;
	}	

	.slick-prev {
		left: -30px;
	}		
`;

export const Content = styled.div`
  width: 100%;
	max-height: 80vh;
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    min-height: 0px;
  }
	flex: none; /* 9 0 auto;*/
	display: flex;
	${flexFix}
	flex-flow: column nowrap;
	justify-content: ${props => props.verticalCenter ? 'center' : 'flex-start'};

	form.comment-form {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	&.pad{
		padding: 30px;

		@media(min-width: 900px) {
			padding: 60px;
		}
	}

	&.scrollable{
		overflow: auto;
	}

	h3{
		font-size: 25px;
		margin-bottom: 30px;
	}

	[data-vimeo-initialized] {
		position: absolute;
	}

  .slick-viewpoints {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .slick-arrow {
    transform: scale(1.8);
  }

  .slick-list, .slick-slider {
    position: static;
  }
`;

const buttonStyle = css`  
	box-shadow:inset 0px 1px 0px 0px #54a3f7;
	background:linear-gradient(to bottom, #007dc1 5%, #0061a7 100%);
	background-color:#007dc1;
	border-radius:3px;
	border:1px solid #124d77;
	display:inline-block;
	cursor:pointer;
	color:#ffffff;
	font-size:16px;
	padding:9px 24px;
	text-decoration:none;
	text-shadow:0px 1px 0px #154682;

	&:hover {
		background:linear-gradient(to bottom, #0061a7 5%, #007dc1 100%);
		background-color:#0061a7;
	}

	&:active {
		position:relative;
		top:1px;
	}
`

export const LinkButton = styled.a`
	${buttonStyle}
`;

export const Button = styled.button`
	${buttonStyle}
`

export const FormRow = styled.div`
	width: 100%;
	${'' /* display: flex;
	flex-direction: column; */}
	margin-bottom: 10px;

	label{
		font-size: 16px;
		line-height: 1.3;
		margin-bottom: 10px;
	}

	> label {
		font-weight: 500;
	}

	input, textarea{
		border: 1px solid #ddd;
		padding: 10px 15px;
		font-family: 'Poppins', sans-serif;
		font-size: 16px;
		margin-bottom: 20px;

		&:not([type='radio']):not([type='checkbox']) {
			width: 100%;
		}

		@media(min-width: 900px) {
			font-size: 18px;
		}		
	}

	textarea{
		resize: vertical;
	}
`;

export const ExtraButtonsContainer = styled.div`
  padding: 10px;
  text-align: center;

  a {
    margin-right: 5px;

    &:last-child {
      margin-right: 0;
    }
  }
`;